import { TIMELINE_CONFIG_WARNINGS } from '../constants'

export default {
  state: {
    screen: {
      id: 0,
      name: '',
      label: '',
    },
    timelineWarning: {
      warning: '',
      color: 'info'
    },
  },

  getters: {
    screenById: (state) => (id) => {
      if (String(state.screen.id) === String(id)) {
        return state.screen
      }
      return null
    },

    hasScreenBlocks: (state) => {
      return state.screen.blocks && state.screen.blocks.length > 0
    },

    screenBlockIds: (state) => {
      return state.screen.blocks.map(b => b.id)
    },

    isScreenTimeline: (state) => {
      if (state.screen.name === 'timeline' || state.screen.name === 'timeline_v2') {
        return true
      }
      return false
    },

    screenTimelineConfig: (state) => {
      if (!state.screen.blocks || state.screen.blocks.length < 2) {
        return TIMELINE_CONFIG_WARNINGS.get('LESS_THEN_TWO_BLOCKS')
      }
      if (state.screen.blocks[0].meta.autofill !== 'my_timeline') {
        if (state.screen.blocks[0].meta.autofill !== 'my_timeline_v2') {
          return TIMELINE_CONFIG_WARNINGS.get('FIRST_BLOCK_MY_TIMELINE')
        }
      }
      if (state.screen.blocks[1].block_type !== 'links') {
        return TIMELINE_CONFIG_WARNINGS.get('SECOND_BLOCK_LINK')
      } 
      if (state.screen.blocks.length > 2) {
        return TIMELINE_CONFIG_WARNINGS.get('TOO_MANY_BLOCKS')
      }
      return TIMELINE_CONFIG_WARNINGS.get('SUCCESS')
    }

  },

  actions: {
    getScreen({ commit, dispatch, getters }, { $api, id }) {
      $api.get(`screen/${id}`)
        .then((response) => {
          commit('setScreen', response.data)
        })
        .then(() => {
          if (getters.isScreenTimeline) {
            dispatch('checkConfigTimeline')
          }
          dispatch('getBlocks', { $api })
        })
        .catch(error => dispatch('throwError', error))
    },

    newScreen({ commit, dispatch, state }, { $api, $router }) {
      commit('deleteScreenZero')
      $api.post('screen/', state.screen)
        .then((response) => {
          commit('setNewScreen', response.data.id)        
          $router.push({ path: `${response.data.id}` })
      })
      .catch(error => dispatch('throwError', error))
    },

    saveScreen({ dispatch, getters, state }, { $api }) {
      $api.put('screen/', state.screen)
        .then(() => {
          if (getters.hasScreenBlocks) {
            dispatch('saveBlocksToScreen', { $api })
          } else {
            dispatch('closeWarningsOfType', 'screen')
          }
        })
        .catch(error => dispatch('throwError', error))
    },

    deleteScreen({ dispatch, commit, state }, { $api, $router }) {
      $api.delete(`screen/${state.screen.id}`)
        .then(() => {
          $router.push({ path: '/screens' })
          commit('cleanScreen')
        })
        .catch(error => { 
          if (error.response.status === 405) {
            error = { 
              'hasError': error.response.data.detail.message,
              'errorAction': error.response.data.detail.action
            }
          }
          dispatch('throwError', error)
          
        })
    },

    saveBlocksToScreen({ dispatch, state }, { $api }) {
      $api.delete(`remove_blocks_from_screen/?screen_id=${state.screen.id}`)
        .then(() => {
          const block_ids = state.screen.blocks.map((bl, i) => [bl.id, i])
          $api.post(`save_blocks_to_screen/`, {
            block_ids,
            screen_id: state.screen.id
          })
          .then(() => {
            dispatch('closeWarningsOfType', screen)
          })
          .catch(error => dispatch('throwError', error))
        })
        .catch(error => dispatch('throwError', error))
    },

    addBlockToScreen({ commit, getters }, { id }) {
      const block = getters.blockById(id) // from all blocks
      commit('addScreenBlock', block)
    },

    checkConfigTimeline({ commit, getters }) {
      const check = getters.screenTimelineConfig
      commit('setTimelineWarning', check)
    }
  },

  mutations: {
    setScreen(state, data) {
      const { screen, blocks } = data
      screen.blocks = blocks
      state.screen = screen
    },

    cleanScreen(state) {
      state.screen = {
        id: 0,
        name: '',
        label: '',
        blocks: [],
      }
    },

    setNewScreen(state, id) {
      state.screen = {
        ...state.screen, id, blocks: []
      }
    },

    setScreenBlocks(state, blocks) {
      state.screen.blocks = blocks
    },

    addScreenBlock(state, block) {
      state.screen.blocks.push(block)
    },

    moveScreenBlock(state, { oldIndex, newIndex }) {
      const { blocks } = state.screen
      blocks.splice(newIndex, 0, blocks.splice(oldIndex, 1)[0])
      state.screen.blocks = blocks
    },

    removeScreenBlock(state, id) {
      state.screen.blocks = state.screen.blocks.filter(bl => bl.id !== id)
    },

    deleteScreenZero(state) {
      if (state.screen.id === 0) {
        delete state.screen.id
      }
    },

    setTimelineWarning(state, warning) {
      state.timelineWarning = warning
    },

  }
}
